import { create } from "zustand";
import { loadRazorpayScript } from "../../utils/utils";
import { verifyPayment, getOrderToken } from "../../apiEndpoints/navutils";


export type CoupanItem = {
    id: number;
    title: string;
    description: string;
    price: string;
    fordays: number,
    coupanCode?: string | undefined
};

type CoupanScreenState = {
    helpUrl: string,
    hideActivityIndicator: boolean,
    coupans: CoupanItem[],
    openendCoupanCode: CoupanItem | undefined,
    loadItems: () => void;
    logout: (finishedTask: () => void) => void,
    handleDeleteAccount: (finishedTaks: () => void) => void;
    toggleActivityIndicator: () => void;
    handleBuy: (item: CoupanItem) => void;

};

type itemsResponse = {
    items: CoupanItem[],
    helpUrl: string
}


function getCsrfToken(): string | null {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute("content") : null;
}

async function getItems(): Promise<itemsResponse> {
    const csrf = getCsrfToken();
    const response = await fetch('/coupons', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: 'include',
    });
    const data = await response.json()
    const items: CoupanItem[] = data.coupons
    return {
        items,
        helpUrl: data.contact_whatsapp
    };
}

async function performLogOut(): Promise<Boolean> {
    const csrf = getCsrfToken();
    const response = await fetch('/logout', {
        method: 'POST', // Laravel usually expects POST for logout
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            "X-CSRF-TOKEN": csrf || ""
        },
        credentials: 'include', // important if using session cookies
    });

    try {
        const data = await response.json();
        if (data.message) {
            window.alert(data.message);
            return true
        }
    } catch (e) {
        window.alert(e);
        return false

    }
    return false

}

async function handleDeleteAccount(): Promise<Boolean> {
    const csrf = getCsrfToken();
    const response = await fetch('/delete-account', {
        method: 'DELETE',
        credentials: 'include',
    });
    const data = await response.json();
    if (data.message) {
        window.alert(data.message);
        return true
    } else {
        window.alert(data.error);
        return false;
    }
}

export const useCoupanStore = create<CoupanScreenState>((set, get) => ({
    openendCoupanCode: undefined,
    hideActivityIndicator: false,
    helpUrl: "",
    coupans: [],
    loadItems: async () => {
        await loadRazorpayScript();
        set({ hideActivityIndicator: true })
        const items = await getItems();
        console.log(items);
        set({ hideActivityIndicator: false })
        set({ coupans: items.items })
        set({ helpUrl: items.helpUrl })

    },
    logout: async (finishedTask) => {
        const result = await performLogOut();
        set({ hideActivityIndicator: false })
        if (result) {
            finishedTask();
        }

    },
    handleDeleteAccount: async (finishedTaks) => {
        const result = await handleDeleteAccount()
        set({ hideActivityIndicator: false })
        if (result) {
            finishedTaks()
        }

    },
    toggleActivityIndicator: () => {
        set((state) => ({
            hideActivityIndicator: !state.hideActivityIndicator,
        }))
    },
    handleBuy: async (item) => {

        set({ hideActivityIndicator: true });

        const order = await getOrderToken(item);

        set({ hideActivityIndicator: false });

        const options = {
            key: "rzp_test_SNN3ML9MH3gB91",
            amount: order.amount,
            currency: order.currency,
            name: "Coupon Store",
            description: item.title,
            order_id: order.id,

            handler: async (response: any) => {

                set({ hideActivityIndicator: true });

                try {

                    const result = await verifyPayment(response, item);
                    console.log("result");
                    console.log(result);

                    if (!result.success) {
                        alert(result.message);
                        set({ hideActivityIndicator: false });
                        return;
                    }

                    const { coupans } = get();

                    set({
                        hideActivityIndicator: false,
                        coupans: coupans.map((c) =>
                            c.id === item.id
                                ? { ...c, coupanCode: result.coupan_code }
                                : c
                        ),
                    });

                } catch (error) {

                    console.error(error);
                    set({ hideActivityIndicator: false });
                    alert("Server error during verification");

                }
            },

            modal: {
                ondismiss: function () {
                    alert("Payment cancelled by user.");
                },
            },

            theme: {
                color: "#1e90ff",
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    }

}));